import styled from '@emotion/styled';
import { connect } from 'react-redux';
import { ProjectsActions } from 'redux/actions';
import LikeIcon from './Icons/LikeIcon';
import { LoginForm } from '../../../../../components';
import { Modal } from '../../../../../utils';
import React, { useEffect, useMemo, useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';

function LikeLoginPrompt() {
  return (
    <LikeLoginContent>
      <LikeLoginInfo>
        <InfoCircleOutlined />
        <span>
          Zum Folgen eines Projekts benötigst du ein Konto.
        </span>
      </LikeLoginInfo>
      <LoginForm />
    </LikeLoginContent>
  );
}

function LikeButton({ project, ml, mr, dispatch, noBorder, absoluteRight, viewMode }) {
  const isLoggedIn = useMemo(() => {
    const client = localStorage.getItem('client');
    const uid = localStorage.getItem('uid');
    const access = localStorage.getItem('access-token');
    const user = localStorage.getItem('user');

    return !!(user && access && uid && client);
  }, []);

  const [isLikedLocal, setIsLikedLocal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    setIsLikedLocal(!!project?.liked);
  }, [project?.liked]);

  const handleLike = () => {

    if(viewMode){
      return;
    }

    if (!isLoggedIn) {
      setShowLoginModal(true);
      return;
    }

    if (isLikedLocal || project?.liked) {
      setIsLikedLocal(false);
      dispatch(ProjectsActions.unlikeProject(project.id));
    } else {
      setIsLikedLocal(true);
      dispatch(ProjectsActions.likeProject(project.id));
    }
  };

  if (absoluteRight) {
    return (
      <>
        <AbsoluteLikeButton onClick={handleLike}>
          <LikeIcon shouldWhite={true} isLiked={isLikedLocal} />
        </AbsoluteLikeButton>

        <Modal
          showModal={showLoginModal}
          handelCloseModal={() => setShowLoginModal(false)}
        >
          <LikeLoginPrompt />
        </Modal>
      </>
    );
  }

  return (
    <>
      <LikeWrapper style={{ marginRight: mr, marginLeft: ml }}>
        <LikeButtonItem
          onClick={handleLike}
          isLiked={isLikedLocal}
          noBorder={noBorder}
        >
          <LikeIcon isLiked={isLikedLocal} />

          <LikeText>{project?.likes_count ?? 0}</LikeText>
        </LikeButtonItem>

        <LikeToolTip className="like-tooltip">
          {isLikedLocal ? 'Projekt folgen' : 'Projekt folgen'}
        </LikeToolTip>
      </LikeWrapper>

      <Modal
        showModal={showLoginModal}
        handelCloseModal={() => setShowLoginModal(false)}
      >
        <LikeLoginPrompt />
      </Modal>
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(null, mapDispatchToProps)(LikeButton);

const LikeLoginContent = styled.div`
  width: 100%;
  max-width: 400px;
`;

const LikeLoginInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 24px 20px;
  padding: 12px;
  border: 1px solid #d9e9c8;
  border-radius: 8px;
  background: #f5fbee;
  color: #414651;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  text-align: left;

  .anticon {
    flex: 0 0 auto;
    margin-top: 2px;
    color: #608b2f;
    font-size: 16px;
  }
`;

const LikeWrapper = styled.div`
  position: relative;
  display: inline-flex;

  &:hover .like-tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
  }
`;

const LikeToolTip = styled.div`
  position: absolute;
  left: 50%;
  top: -48px;

  transform: translateX(-50%) translateY(6px);
  padding: 8px 12px;

  min-width: 124px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #0a0d12;
  border-radius: 8px;

  box-shadow: 0px 12px 16px -4px rgba(10, 13, 18, 0.08),
    0px 4px 6px -2px rgba(10, 13, 18, 0.03),
    0px 2px 2px -1px rgba(10, 13, 18, 0.04);

  font-family: 'Inter';
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;

  color: #ffffff;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 999;

  white-space: nowrap;

  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;

    transform: translateX(-50%) rotate(45deg);

    width: 12px;
    height: 12px;

    background: #0a0d12;
  }
`;

const LikeButtonItem = styled.div`
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  padding: 10px 18px;
  gap: 6px;

  width: auto;
  height: 44px;

  background: ${(props) => (props.isLiked ? '#f5fbee' : '#fff')};
  border: 1px solid ${(props) => (props.isLiked ? '#acdc79' : '#d5d7da')};

  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);

  border-radius: 8px;

  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: #f5fbee;
    border-color: #acdc79;
    cursor: pointer;
  }
`;

const LikeText = styled.span`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  color: #3f621a;
  white-space: nowrap;
`;

const AbsoluteLikeButton = styled.div`
  position: absolute;
  right: 13px;
  top: 10px;
  z-index: 99;
  cursor: pointer;
`;
